import React from "react";
import { useParams } from "react-router-dom";
import PostulacionContainer from "./PostulacionContainer";
import PostulacionForm from "./PostulacionForm";

const PostulacionHome: React.FC = () => {
  const { concursoPk } = useParams();

  return (
    <PostulacionContainer noIntro>
    <h4 className="pb-3">Formulario de postulación</h4>
      <PostulacionForm concursoPk={concursoPk} />
    </PostulacionContainer>
  );
};

export default PostulacionHome;
